import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';
import Hero from '../components/Hero';
import posts from '../content_stub/sample_posts.js';
import { SEO, buildArticleJsonLd } from '../utils/seo';
import { base } from '../seo/keywords';

export default function BlogDetails() {
  const { slug } = useParams();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return (
      <Container sx={{ py: 6 }}>
        <Typography variant="h3">Post Not Found</Typography>
        <Button component={RouterLink} to="/blog" sx={{ mt: 2 }} variant="contained">Back to Blog</Button>
      </Container>
    );
  }

  const title = post.title + ' | Rite HVAC Blog';
  const description = post.excerpt;
  const canon = base + '/blog/' + post.slug;
  const jsonLd = [buildArticleJsonLd(post)];

  return (
    <Box>
      <SEO title={title} description={description} canonical={canon} jsonLd={jsonLd} openGraph={{ image: post.featuredImage }} />
      <Hero title={post.title} subtitle={post.excerpt} bgImage={post.featuredImage} ctaText="Book Service" ctaLink="/book" />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="overline" color="text.secondary">
          {post.category} · By {post.author} · {post.date}
        </Typography>
        <Typography paragraph style={{ whiteSpace: 'pre-line' }}>{post.content}</Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6">Related Posts</Typography>
          <ul>
            {posts.slice(0, 4).filter(p => p.slug !== post.slug).map(p => (
              <li key={p.slug}><Button component={RouterLink} to={'/blog/' + p.slug}>{p.title}</Button></li>
            ))}
          </ul>
        </Box>

        <Box sx={{ mt: 3, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
          <Typography variant="h6">Comments</Typography>
          <Typography variant="body2" color="text.secondary">Comments integration placeholder (Disqus/Remark42/Staticman).</Typography>
        </Box>
      </Container>
    </Box>
  );
}
